export default __webpack_public_path__ + "static/VehicleSearchText-b118677bd445c07bc044cd7a98b430e0.jpg";